<template>
	<div class="breadcrumbs">
		<Breadcrumb v-for="crumb in normalizedCrumbs"
			:key="crumb.text"
			:disabled="disabled"
			:text="crumb.text"
			:is-active="crumb.isActive"
			:show-chevron="!crumb.isLast"
			@click="onBreadcrumbClick( crumb )"
		/>
	</div>
</template>

<script>
import Breadcrumb from "./Breadcrumb";

export const makeCrumb = ( { text = "", route = "", isActive = false, } ) => {
	return {
		text,
		route,
		isActive,
	};
};

export default {
	name: "Breadcrumbs",
	events: [ "activate", ],
	components: {
		Breadcrumb,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		/** [ { text:String, route:String, isActive:Boolean, }, ... ] */
		crumbs: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		normalizedCrumbs() {
			const { crumbs, } = this;
			const lastIndex = Math.max( 0, crumbs.length - 1 );
			return crumbs.map( ( crumb, index ) => {
				return {
					...crumb,
					isLast: index === lastIndex,
				};
			} );
		},
	},
	methods: {
		onBreadcrumbClick( crumb ) {
			if ( this.disabled ) {
				return;
			}
			const { text, route, isActive, } = crumb;
			this.$emit( "activate", { text, route, isActive, } );
		},
	},
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
}
</style>

<style lang="scss">
.breadcrumbs {
	.breadcrumb {
		// at smaller resolutions, hide all but the last TWO breadcrumbs
		// and constrain their size
		display: none;
		max-width: 9.5rem;

		&:nth-last-of-type(1),
		&:nth-last-of-type(2) {
			display: flex;
		}
	}

	@include for-size('sm') {
		.breadcrumb {
			display: flex;
		}

		.breadcrumb:last-of-type {
			max-width: unset;
		}
	}
}
</style>
